import {
  BreakpointQueryName,
  getSpacing, getTypography, SpacingName, ThemedFunctor, TypographyName,
} from '@doveit/lego';
import { css } from 'styled-components';

export const base = css`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const body = css`
  flex: 1;
`;

export const header: ThemedFunctor = ({
  theme,
}) => css`
  position: relative;

  &:after {
    content: ' ';
    position: absolute;
    left: 3rem;
    top: 50%;
    right: 0;
    height: 2px;
    transform: translateY(-50%);
    background-color: ${theme.palettes.neutrals.light};
  }
`;

export const stepNumber: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
  align-items: center;
  border: 2px solid ${theme.palettes.neutrals.light};
  border-radius: 50%;
  color: ${theme.palettes.neutrals.medium};
  display: flex;
  height: 2.5rem;
  justify-content: center;
  text-align: center;
  width: 2.5rem;
`;

export const arrow: ThemedFunctor = ({
  theme,
}) => css`
  display: none;
  width: 0;
  height: 0;
  border-top: 0.5rem solid transparent;
  border-bottom: 0.5rem solid transparent;
  border-left: 0.5rem solid ${theme.palettes.neutrals.light};
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: block;
  }
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H3)}
  ${getSpacing.margin(theme, [SpacingName.SMALL, 0])}
`;

export const description: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)}
  ${getSpacing.marginBottom(theme, SpacingName.SMALL)}
  color: ${theme.palettes.neutrals.medium};
`;
